import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopSideFooter } from '@zurich-base-ui/layout.top-side-footer';
import styles from './Layout.module.scss';

const Landing: React.FC = () => {
  return (
    <div className={styles.background}>
      <TopSideFooter>
        <TopSideFooter.Main>
          <Outlet />
        </TopSideFooter.Main>
      </TopSideFooter>
    </div>
  );
};

export default Landing;
